import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { client } from '@Utils'
import { billingQueue as urls } from '@URLS'
import { toast } from '@CommonComponents/toast'

export const CreateInvoiceAccountModal = ({ show, toggle, schools, defaultSchoolId, onCreated }) => {
  const [name, setName] = useState('')
  const [schoolId, setSchoolId] = useState('')
  const [billingContact, setBillingContact] = useState('')
  const [notes, setNotes] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    if (show) {
      setName('')
      setSchoolId(defaultSchoolId || '')
      setBillingContact('')
      setNotes('')
    }
  }, [show, defaultSchoolId])

  const handleSave = async () => {
    if (!name.trim()) {
      toast.error('Account name is required.')
      return
    }
    setSaving(true)
    try {
      const resp = await client.post(urls.createInvoiceAccount(), {
        name: name.trim(),
        school_id: schoolId || null,
        billing_contact: billingContact.trim(),
        notes: notes.trim(),
      })
      toggle(false)
      toast.success(`Invoice account "${resp.data.name}" created.`)
      if (onCreated) onCreated(resp.data)
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to create invoice account.')
    }
    setSaving(false)
  }

  return (
    <Modal show={show} onHide={() => toggle(false)}>
      <Modal.Header>
        <button type="button" className="close" onClick={() => toggle(false)}>
          <span aria-hidden="true">&times;</span>
        </button>
        <Modal.Title>New Invoice Account</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label className="font-weight-bold">
            Account Name <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. MBA Program – Monthly"
            value={name}
            onChange={e => setName(e.target.value)}
            autoFocus
          />
        </div>
        <div className="form-group">
          <label className="font-weight-bold">School</label>
          <select
            className="form-control"
            value={schoolId}
            onChange={e => setSchoolId(e.target.value)}
          >
            <option value="">Select school…</option>
            {schools.map(s => (
              <option key={s.id} value={s.id}>
                {s.name}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label className="font-weight-bold">Billing Contact</label>
          <input
            type="text"
            className="form-control"
            placeholder="Name or email address"
            value={billingContact}
            onChange={e => setBillingContact(e.target.value)}
          />
        </div>
        <div className="form-group mb-0">
          <label className="font-weight-bold">Notes</label>
          <textarea
            className="form-control"
            rows="3"
            placeholder="Any special invoicing instructions or notes…"
            value={notes}
            onChange={e => setNotes(e.target.value)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-myed btn-default btn-default-myed"
          onClick={() => toggle(false)}
          disabled={saving}
        >
          Cancel
        </button>
        <button
          className="btn btn-myed btn-primary btn-primary-myed"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? <i className="fa-regular fa-spinner fa-spin mr-1" /> : null}
          Save Invoice Account
        </button>
      </Modal.Footer>
    </Modal>
  )
}
